import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BackToTop from './backToTop';

export default class OnScrollBackToTop extends PureComponent {
  constructor() {
    super();

    this.state = { visible: false };

    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const { visible: oldVisible } = this.state;
    const { offset } = this.props;
    const newVisible = window.pageYOffset >= offset;

    if (oldVisible !== newVisible) {
      this.setState({ visible: newVisible });
    }
  }

  render() {
    const { visible } = this.state;
    return <BackToTop {...this.props} visible={visible} />;
  }
}

OnScrollBackToTop.propTypes = {
  offset: PropTypes.number,
};

OnScrollBackToTop.defaultProps = {
  offset: 100,
};
